/* eslint-disable import/no-anonymous-default-export */
import siteConfig from "../siteConfig";

export default {
  path: "/parcel-problems",
  shortTitle: "Parcel problems",
  title: "Lost, delayed, missing or damaged parcels",
  category: "Orders and delivery",
  summary: "A practical evidence and tracked-carrier investigation process for delivery problems.",
  updated: "5 November 2026",
  sections: [
    {
      heading: "When this process applies",
      body: [
        "Follow this route for stalled tracking, an unfound package carrying a delivered scan, a wet or crushed carton, absent contents or breakage. Treat an open food seal, sharp edge, chip or unstable object as a safety issue and leave the affected goods unused.",
      ],
    },
    {
      heading: "Immediate steps",
      body: [
        "For a delivery marked complete, first check the full address, building reception, safe locations and household members. Do not handle sharp fragments with bare hands, light a damaged candle holder, drink from cracked ceramics or consume food with a compromised seal.",
        "Email customer care as soon as practical with the order number, recipient name, delivery address, a concise account and photographs of all sides of the parcel, its label, internal cushioning and the affected item. Keep everything until told the evidence is sufficient. There is no invented 24- or 48-hour forfeiture rule; early notice simply makes an investigation more reliable.",
      ],
    },
    {
      heading: "Investigation and outcome",
      body: [
        `Customer care will compare the order and supplied evidence, then open a trace with the carrier named in the dispatch email. The current services are ${siteConfig.fulfilment.carriers.domestic}, ${siteConfig.fulfilment.carriers.regional}, or ${siteConfig.fulfilment.carriers.international}. Most traces receive an initial carrier response within 5–10 business days, although border or final-mile investigations can take longer.`,
        "Depending on verified facts, stock and the customer's legal rights, a resolution may be replacement of the affected line, missing-part fulfilment, repair where agreed and appropriate, price reduction, cancellation, or refund to the original method. A replacement may not be practical for one-off glaze, fibre or stock variations.",
      ],
    },
    {
      heading: "Exceptions",
      body: [
        "A pre-disclosed variation in fibre tone, weave, glaze or handmade form is distinct from transit harm. Post-delivery effects of misuse, moisture, flame, thermal shock, unsuitable cleaning or disregarded warnings need their own assessment. Compulsory remedies for failed delivery, danger, defect or material mismatch remain untouched.",
      ],
    },
  ],
};
